import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X, Phone, ChevronDown } from "lucide-react";
import { BRAND, NAV } from "../mock";

const Logo = () => (
  <Link to="/" className="flex items-center gap-3" aria-label="EMC Industrial Home">
    <div className="logo-block">
      <div className="flex items-center gap-2">
        <div className="flex flex-col leading-none">
          <span className="text-[26px] font-bold text-[#0a0a0a] tracking-tight">EMC</span>
          <span className="text-[8px] font-semibold text-[#0a0a0a] tracking-[0.25em]">INDUSTRIAL CORP.</span>
        </div>
        <div className="flex flex-col items-center justify-center bg-[#f5a623] border border-[#0a0a0a] px-1.5 py-0.5">
          <span className="text-[10px] font-bold text-[#c8102e] leading-none">TATU</span>
          <span className="text-[5px] font-bold text-[#0a0a0a] leading-none mt-0.5">DEALER</span>
        </div>
      </div>
    </div>
  </Link>
);

export default function Header() {
  const [open, setOpen] = useState(false);
  const [openGroup, setOpenGroup] = useState(null);
  const location = useLocation();

  return (
    <header className="sticky top-0 z-50 bg-[#f5a623] border-b-4 border-[#0a0a0a]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-[88px]">
          <Logo />

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-8">
            {NAV.map((item) =>
              item.children ? (
                <div key={item.label} className="nav-item relative">
                  <button className="nav-link flex items-center gap-1 text-[13px] font-semibold uppercase tracking-wider text-[#0a0a0a]">
                    {item.label} <ChevronDown className="w-3.5 h-3.5" />
                  </button>
                  <div className="nav-dropdown absolute top-full left-1/2 -translate-x-1/2 pt-4">
                    <div className="bg-[#0a0a0a] min-w-[240px] py-2 shadow-2xl">
                      {item.children.map((c) => (
                        <Link
                          key={c.label}
                          to={c.path}
                          className="block px-5 py-2.5 text-[13px] text-white hover:bg-[#f5a623] hover:text-[#0a0a0a] transition-colors"
                        >
                          {c.label}
                        </Link>
                      ))}
                    </div>
                  </div>
                </div>
              ) : (
                <Link
                  key={item.label}
                  to={item.path}
                  className={`nav-link text-[13px] font-semibold uppercase tracking-wider text-[#0a0a0a] flex items-center gap-2 ${
                    location.pathname === item.path ? "active" : ""
                  }`}
                >
                  {item.label}
                  {item.badge && (
                    <span className="bg-[#c8102e] text-white text-[9px] font-bold px-1.5 py-0.5 tracking-wider">
                      {item.badge}
                    </span>
                  )}
                </Link>
              )
            )}
          </nav>

          {/* Phone CTA */}
          <a
            href={BRAND.phoneHref}
            className="hidden md:flex items-center gap-2 bg-[#0a0a0a] text-white px-5 py-3 font-semibold text-sm hover:bg-[#1a1a1a] transition-colors"
          >
            <Phone className="w-4 h-4" />
            {BRAND.phone}
          </a>

          {/* Mobile toggle */}
          <button
            className="lg:hidden text-[#0a0a0a] p-2"
            onClick={() => setOpen((v) => !v)}
            aria-label="Toggle menu"
          >
            {open ? <X className="w-7 h-7" /> : <Menu className="w-7 h-7" />}
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      {open && (
        <div className="lg:hidden bg-[#0a0a0a] mobile-menu-enter">
          <div className="px-4 py-4 flex flex-col">
            {NAV.map((item) =>
              item.children ? (
                <div key={item.label} className="border-b border-[#1f1f1f]">
                  <button
                    onClick={() =>
                      setOpenGroup(openGroup === item.label ? null : item.label)
                    }
                    className="w-full flex items-center justify-between py-3 text-white font-semibold text-sm uppercase tracking-wider"
                  >
                    {item.label}
                    <ChevronDown
                      className={`w-4 h-4 transition-transform ${
                        openGroup === item.label ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                  {openGroup === item.label && (
                    <div className="pb-3 pl-3">
                      {item.children.map((c) => (
                        <Link
                          key={c.label}
                          to={c.path}
                          onClick={() => setOpen(false)}
                          className="block py-2 text-sm text-[#cccccc] hover:text-[#f5a623]"
                        >
                          {c.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              ) : (
                <Link
                  key={item.label}
                  to={item.path}
                  onClick={() => setOpen(false)}
                  className="py-3 border-b border-[#1f1f1f] text-white font-semibold text-sm uppercase tracking-wider flex items-center gap-2"
                >
                  {item.label}
                  {item.badge && (
                    <span className="bg-[#c8102e] text-white text-[9px] font-bold px-1.5 py-0.5">
                      {item.badge}
                    </span>
                  )}
                </Link>
              )
            )}
            <a
              href={BRAND.phoneHref}
              className="mt-4 flex items-center justify-center gap-2 bg-[#f5a623] text-[#0a0a0a] py-3 font-bold"
            >
              <Phone className="w-4 h-4" />
              {BRAND.phone}
            </a>
          </div>
        </div>
      )}
    </header>
  );
}
